const validateRunWorkflow = ({ step }) => {
  const workflowId = step?.options?.workflowId;

  if (!workflowId) {
    return { status: 'invalid', message: 'Select a workflow' };
  }

  return { status: 'valid' };
};

export default validateRunWorkflow;
